import information from './contractFrom/information';
import product from './contractFrom/product';
import { contractInfo } from './request';
export default {
  components: {
    information,
    product
  },
  data() {
    return {
      current: -1,
      stepStyle: {
        // marginBottom: '60px',
        // boxShadow: '0px -1px 0 0 #e8e8e8 inset',
        padding: '0 10%'
      },
      id: this.$route.params.id,
      infoObj: {}
    };
  },
  created() {
    this.getInfoFun();
  },
  methods: {
    nextFun(val) {
      if (val) {
        this.id = val.contractId;
        this.getInfoFun();
      }
      this.current = this.current + 1;
    },
    getInfoFun() {
      if (this.id != -1) {
        contractInfo({
          contractId: this.id
        }).then(res => {
          console.log(res, 55);
          this.infoObj = res;
          if (this.current == -1) {
            this.current = 0;
          }
        });
      } else {
        this.current = 0;
      }
    },
    prevFun() {
      this.current = this.current - 1;
    }
  }
};